import {isScalar} from '../services/DotAccessor/types-utils';

function toUrlParamString(key: string, value: any): string {
	if ([null, undefined].includes(value) || !String(value).trim().length) {
		return `${key}=`;
	}

	return `${key}=${encodeURIComponent(value)}`;
}

function arrayToUrlParams(baseKey: string, array: any[]): string {
	const result = [];
	baseKey += '[]';

	for (let i = 0; i < array.length; i++) {
		result.push(toUrlParams(baseKey, array[i]));
	}

	return result.filter(c => c.trim().length).join('&');
}

function objectToUrlParams(baseKey: string, params: Record<any, any>): string {
	const result = [];
	const baseKeyUndefined = !baseKey;

	for (const [key, value] of Object.entries(params)) {
		result.push(toUrlParams(baseKeyUndefined ? key : `${baseKey}[${key}]`, value));
	}

	return result.filter(c => c.trim().length).join('&');
}

function toUrlParams(key: string, value: Record<any, any> | any[]): string {
	if (isScalar(value)) {
		return toUrlParamString(key, value);
	}

	if (Array.isArray(value)) {
		return arrayToUrlParams(key, value);
	}

	return objectToUrlParams(key, value);
}

export default abstract class URLSearchParamsGenerator {
	/**
	 * @throws Error
	 */
	private constructor() {
		throw new Error('Invalid invocation');
	}

	/**
	 * @param {object|array} params
	 * @return {string}
	 */
	static toString(params: Record<any, any> | any[]) {
		return toUrlParams('', params);
	}
}
